export default __webpack_public_path__ + "static/media/23.70d9b00f.png";